<template>
    <div class="team-exit">
        <p class="exit-tip nowrap"><span v-t="'ExitConfirm'"></span> <b>{{c.name}}</b></p>
        
        <p class="exit-tip exit-sub" v-if="currentTeam.creator != id" v-t="'UserExitTip'"></p>
        <template v-if="currentTeam.creator == id">
            <p class="exit-tip exit-sub" v-t="'ExitTip'"></p>
            <div class="setting-name mbox nowrap" >
                <img v-for="(item,i) in c.members" :key="i" class="setting-member" :src="item.avatar" alt="">
                <span class="setting-mlength">{{$t('MemberLength',{num:c.member_count})}}</span>
            </div>
        </template>
        <div class="dialog-foot">
            <div v-if="role == 'creator'" :class="`exit-team-check ${checked ? 'selected' : ''}`" @click="() => checked = !checked">
                <div class="checkbox"></div><span v-t="'ExitTeamCheck'"></span>
            </div>
            <el-button 
                size="mini" 
                @click="cancel" 
                v-cloak>{{$t('Cancel')}}
            </el-button>
            <el-button
                :disabled="!checked && role == 'creator'"
                :loading="linking"
                @click="() => doexit({groupid:currentTeam.teamid ,role})" 
                type="danger" 
                size="mini" 
                v-cloak>{{$t('Confirm')}}
            </el-button>
        </div>
    </div>
</template>

<script>
import {mapActions, mapState, mapMutations} from 'vuex'
import Loading from '@/components/Loading'
export default {
    data(){
        return {
            checked: false
        }
    },
    created(){

    },
    computed:{
        ...mapState([
            'dialogData'
        ]),
        ...mapState('team',[
            'currentTeam',
            'linking'
        ]),
        ...mapState('user',[
            'id'
        ]),
        c(){
            return this.currentTeam
        },
        role(){
            return this.c.member_role
        }
    },
    methods:{
        ...mapMutations([
            'SHOW_DIALOG'
        ]),
        ...mapActions('team',[
            'doexit'
        ]),
        cancel(){
            this.SHOW_DIALOG({
                title: this.$t('Settings'),
                current: 'Settings'
            })
        }
    }
}
</script>

<style>
.team-exit{
    padding-top: 30px;
    border-top: 1px solid #e7e9eb;
}
.exit-tip{
    line-height: 22px;
}
.exit-sub{
    margin-top: 15px;
}
.setting-name.mbox{
    font-size: 0;
    flex: 1;
    display: flex;
    align-items: center;
}
.setting-member{
    width: 24px;
    height: 24px;
    border-radius: 50%;
    vertical-align: middle;
    border: 2px solid #fff;
    margin-right: -8px;
}
.setting-mlength{
    margin-left: 14px;
    font-size: 14px;
    line-height: 40px;
    color: #949aae;
}
.exit-team-check {
    float: left;
    line-height: 32px;
    position: relative;
    padding-left: 20px;
    cursor: pointer;
}
.exit-team-check .checkbox{
    display: block;
}
</style>


// WEBPACK FOOTER //
// src/components/dialog/team/ExitTeam.vue